export const ADD_BOOKS = "ADD_BOOKS";
export const REMOVE_BOOKS = "REMOVE_BOOKS";
export const SHOW_LOADER = "SHOW_LOADER";
export const REMOVE_LOADER = "REMOVE_LOADER";
export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";
export const FETCH_BOOKLIST_SUCCESS = "FETCH_BOOKLIST_SUCCESS";

export const SET_INPUT_AUTHOR = "SET_INPUT_AUTHOR";
export const SET_INPUT_TITLE = "SET_INPUT_TITLE";

export const GET_SINGLE_BOOKLIST_SUCCESS = "GET_SINGLE_BOOKLIST_SUCCESS";

export const SET_UPDATE_INPUTS = "SET_UPDATE_INPUTS";

// ACTION TYPES FOR THE LOGIN AND SIGNUP

export const AUTH_STARTED = "AUTH_STARTED";
export const AUTH_REQUEST_SUCCESS = "AUTH_REQUEST_SUCCESS";
export const AUTH_REQUEST_FAIL = "AUTH_REQUEST_FAIL";
export const RESET_LOADERS = "RESET_LOADERS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const CHECKAUTH = "CHECKAUTH";
export const FRESHEDLOGIN = "FRESHEDLOGIN";
